export const roleAwareTopMenuItem = (item, isConsultant) => {
  if (isConsultant && item.key === 'Evaluation') {
    return { ...item, key: 'Cabinet', path: 'dashboard' };
  }
  return item;
};
